import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {IconButtonUniqueId} from 'components/ui-kit/IconButton';
import {breakpoint, colors} from 'theme';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px 24px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const FullWidthField = styled.div`
    grid-column: 1 / -1;
`;

export const FieldError = styled.div`
    min-height: 18px;
    margin-top: 4px;
    color: ${colors.danger};
    font-size: 12px;
`;

export const FilesField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    @media (min-width: ${breakpoint.tablet}) {
        flex-direction: row;
    }
`;

export const FilesLabel = styled.label`
    font-size: 14px;
    font-weight: 500;
`;

export const RequiredMark = styled.span`
    color: ${colors.danger};
`;

export const Dropzone = styled.div<{isDragActive: boolean}>`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 120px;
    padding: 30px;
    border: 2px dashed
        ${({isDragActive}) => (isDragActive ? colors.brandPrimary : colors.textMuted)};
    border-radius: 8px;
    background-color: ${({isDragActive}) => (isDragActive ? colors.brandLight : colors.white)};
    cursor: pointer;
    outline: none;
    transition: border-color 200ms ease, background-color 200ms ease;

    &:hover,
    &:focus-visible {
        border-color: ${colors.brandPrimary};
        background-color: ${colors.brandLight};
    }
`;

export const DropzoneContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

export const DropzoneText = styled.p`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 14px;
`;

export const DropzoneAction = styled.span`
    color: ${colors.brandPrimary};
    font-weight: 600;
`;

export const DropzoneHint = styled.span`
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const FileTable = styled.div`
    overflow: hidden;
    border: 1px solid #cad5e2;
    border-radius: 10px;
    background-color: ${colors.white};
`;

export const FileTableInner = styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
`;

export const FileTableHeadCell = styled.th`
    padding: 6px 16px;
    border-bottom: 1px solid ${colors.border};
    color: ${colors.darkGrey};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    white-space: nowrap;

    &:last-child {
        width: 142px;
    }
`;

export const FileTableCell = styled.td`
    min-width: 0;
    padding: 8px 16px;
    overflow: hidden;
    color: ${colors.darkGrey};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    vertical-align: middle;

    &:last-child {
        width: 142px;
    }
`;

export const FileName = styled.span`
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FileDeleteButton = styled(IconButtonUniqueId)`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 999px;
    background-color: #f1f5f9;
    transition: background-color 200ms ease;

    &:not(:disabled):hover {
        background-color: ${colors.border};
    }
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    > button {
        width: auto;
        min-width: 140px;
    }
`;

export const SubmitButton = styled(Button)`
    min-width: 160px;
`;
